<template>
  <div class="email-subscribe aside-item" v-if="enabled">
    <div class="aside-item-title">
      <img src="../../../img/message.svg" width="84" alt="" class="message-icon">
      Узнавайте о скидках первым!
    </div>
    <input type="email" placeholder="Введите свой e-mail" v-model="email" @focus="hideErrors" @blur="validate" :disabled="isSent"></input>
    <div class="email-error-message" v-if="invalid">{{ errorMessage }}</div>
    <div v-if="isSent">
      <div class="small-text" style="color: #2dbe00;">
        Мы <span v-if="isSentAgain">пере</span>отправили вам письмо с ссылкой для активации подписки на адрес: {{ email }}
      </div>
      <div class="button-wrapper">
        <button @click="goToMail">Перейти в почту</button>
      </div>
      <div class="small-text text-center" v-if="canSendAgain"><a @click="sendAgain">Перевыслать письмо</a></div>
      <div class="small-text text-center" v-else>Перевыслать письмо<br>(осталось {{ sendAgainDelayMinutes}}:{{ sendAgainDelaySeconds }})</div>
    </div>
    <div v-else>
      <div class="button-wrapper">
        <button @click="subscribe">Подписаться</button>
      </div>
      <div class="small-text">
        Нажимая на кнопку &laquo;Подписаться&raquo; вы даете согласие на <a :href="siteUrl('privacy-policy')" target="_blank">обработку персональных данных</a>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapState } from 'vuex';
import utils from '../../mixins/utils.js';

const subscribed = 'yes';
const subscribedCookie = 'subscribed';

export default {
  name: 'shop-email-subscribe',

  mixins: [utils],

  data() {
    return {
      enabled: false,
      email: '',
      errorMessage: '',
      invalid: false,
      isSent: false,
      isSentAgain: false,
      canSendAgain: false,
      sendAgainDelayMinutes: 1,
      sendAgainDelaySeconds: 0,
    };
  },

  computed: {
    ...mapState(['shop']),
  },

  mounted() {
    this.enabled = (this.$cookies.get(subscribedCookie) !== subscribed);
  },

  methods: {
    delay() {
      this.canSendAgain = false;
      this.sendAgainDelayMinutes = 1;
      this.sendAgainDelaySeconds = 0;
      var tick = setInterval(() => {
        this.sendAgainDelaySeconds--;
        if (this.sendAgainDelaySeconds < 0) {
          this.sendAgainDelaySeconds = 59;
          this.sendAgainDelayMinutes--;
        }
        if (this.sendAgainDelayMinutes < 0) {
          clearInterval(tick);
          this.canSendAgain = true;
        }
      }, 1000);
    },

    goToMail() {
      window.open('http://'+this.email.substring(this.email.indexOf('@') + 1), '_blank');
    },

    hideErrors() {
      this.invalid = false;
      this.errorMessage = '';
    },

    sendAgain() {
      this.isSentAgain = true;
      this.isSent = false;
      this.subscribe();
    },

    setError(errorMessage) {
      this.errorMessage = errorMessage;
      this.invalid = true;
    },

    async subscribe() {
      if (!this.email || this.invalid) {
        return;
      }
      try {
        const response = await axios.post(this.subscribeUrl(), { email: this.email, store: this.shop.slug });
        this.$cookies.set(subscribedCookie, subscribed);
        this.isSent = true;
        this.delay();
      } catch (err) {
        if (err.response.status == 409 || err.response.status == 422) {
          this.setError(err.response.data.errorMessage);
        }
      }
    },

    validate() {
      if (!this.email) {
        return;
      }
      const emailValid = this.validateEmail(this.email)
      if (!emailValid) {
        this.setError('Введен некорректный email');
      }
    },

  }
};
</script>

<style scoped>
.email-subscribe {
  padding: 35px 0;
}

.aside-item-title{
  padding-bottom: 10px;
}

input[type="email"] {
  border: none;
  border-top: 1px solid #dbdce1;
  border-bottom: 1px solid #dbdce1;
  color: #666870;
  font-size: 14px;
  padding: 10px;
  width: 100%;
}

input[type="email"]:disabled {
  background-color: #fff;
}

.email-error-message {
  color: #f00;
  text-align: center;
  padding: 5px;
  font-size: 12px;
}

.small-text {
  font-size: 12px;
  padding: 10px 18px;
}

.small-text a {
  border-bottom: 1px dotted;
}

.text-center {
  text-align: center;
}

.message-icon {
  display: block;
  margin: 0 auto;
}

.button-wrapper {
  padding: 10px 18px;
}

button {
  background-color: #fff;
  border-radius: 3px;
  border: 2px solid #5197e7;
  color: #666870;
  font-size: 16px;
  padding: 15px 10px;
  text-align: center;
  width: 100%;
}

button:hover {
  background-color: #3c90e5;
  color: #fff;
}

button:active {
  background-color: #2a629b;
  border: 2px solid #2a629b;
  color: #fff;
}
</style>
